/*
 * cluutch-pdp-badges.js
 * Met à jour les pastilles de la fiche produit quand la teinte change.
 *
 * Les pastilles du produit (`custom.badges`) restent affichées quelle que soit la teinte ; celles
 * de la teinte (`custom.badges2`) sont remplacées. Même ordre et même règle de fusion que les
 * cartes en collection : produit d'abord, teinte ensuite.
 *
 * Le rendu initial est fait côté serveur : ce script ne prend la main qu'au changement de teinte.
 *
 * Choix structurants :
 * - écoute sur `document` : le thème diffuse `product:variant-change` via dispatchCustomEvent
 *   (app.js), qui émet sur document sans bubbling ;
 * - garde sur `detail.variant` : custom.js re-diffuse le même événement SANS detail sur certaines
 *   fiches, ce qui provoquerait sinon une erreur à chaque changement ;
 * - couleurs restreintes à gold / red / black / grey comme le rendu Liquid
 *   (cluutch-product-badges.liquid, table à tenir en miroir), pour qu'une valeur inattendue
 *   ne sorte pas dans le rouge de solde du thème.
 * Auteur : Cluutch / Studio Hogo.
 */
(function () {
	if (window.cluutchPdpBadgesReady) return;
	window.cluutchPdpBadgesReady = true;

	var COULEURS = ['gold', 'red', 'black', 'grey'];

	function analyser(brut) {
		if (!brut) return [];
		return brut
			.split('\n')
			.map(function (ligne) {
				var parts = ligne.split('|');
				var label = (parts[0] || '').trim();
				if (!label) return null;
				var couleur = (parts[1] || '').trim().toLowerCase();
				return { label: label, couleur: COULEURS.indexOf(couleur) > -1 ? couleur : 'black' };
			})
			.filter(Boolean);
	}

	function rendre(el, pastilles) {
		el.textContent = '';
		pastilles.forEach(function (p) {
			var span = document.createElement('span');
			span.className = 'badge ' + p.couleur;
			span.textContent = p.label;
			el.appendChild(span);
		});
	}

	document.addEventListener('product:variant-change', function (e) {
		// custom.js re-diffuse cet événement sans detail : on l'ignore.
		if (!e.detail || !e.detail.variant) return;

		document.querySelectorAll('[data-cluutch-badges]').forEach(function (el) {
			var parTeinte = {};
			try {
				parTeinte = JSON.parse(el.dataset.variantsBadges || '{}');
			} catch (err) {
				return; // données illisibles : on laisse le rendu du serveur en place
			}
			// Même dédoublonnage que sur les cartes (`custom.js`) : « BEST SELLER » et
			// « BEST-SELLER » désignent le même statut, et ces libellés se saisissent à la
			// main. Sans cela, la teinte choisie répète la pastille portée par le produit.
			var vus = [];
			var pastilles = analyser(el.dataset.productBadges)
				.concat(analyser(parTeinte[e.detail.variant.id]))
				.filter(function (p) {
					var cle = p.label.toUpperCase().replace(/[\s-]+/g, ' ').trim();
					if (vus.indexOf(cle) !== -1) return false;
					vus.push(cle);
					return true;
				});
			rendre(el, pastilles);
		});
	});
})();
